import { 
  Basketball, 
  Timer,
  PersonSimpleRun,
  Barbell,
  HandPalm,
  Star,
  TennisBall,
} from 'phosphor-react';

const TaskIcon = ({ type, points }) => {
  const getIcon = (type) => {
    const iconProps = {
      size: 32,
      color: "#3b82f6",
      weight: "bold"
    };

    switch(type) {
      case 'basket':
        return <Basketball {...iconProps} />;
      case 'time':
        return <Timer {...iconProps} />;
      case 'run':
        return <PersonSimpleRun {...iconProps} />;
      case 'jump':
        return <Barbell {...iconProps} />;
      case 'yoga':
        return <HandPalm {...iconProps} />;
        case 'tennis':
        return <TennisBall {...iconProps} />;
      default:
        return <Star {...iconProps} />;
    }
  };

  return (
    <div className="relative">
      <div className="w-12 h-12 flex items-center justify-center text-blue-600 bg-white rounded-full shadow-md border-2 border-white">
        {getIcon(type)}
      </div>
      {points && (
        <div className="absolute -top-2 -right-2 bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold border-2 border-white">
          {points}
        </div>
      )}
    </div>
  );
};

export default TaskIcon;
